import { Tab, Tabs } from "@mui/material";
import { memo, useCallback } from "react";
import { useStyles } from "./styles";
import { useSelector } from "react-redux";
import { selectQuickOrderData } from "../../../selectors/orders";
import { QuickTradeData } from "../../../reducer/orders.reducer";

export type QuickTradeProductTabsProps = {
    disabled?: boolean,
    onChange: (mode: QuickTradeData["mode"] ) => void
}

const QuickTradeProductTabs: React.FC<QuickTradeProductTabsProps> = ({disabled = false, onChange}) => {

    const { classes, cx } = useStyles();
    const {mode} = useSelector(selectQuickOrderData);

    const onTabChange = useCallback((e: any, value: QuickTradeData["mode"]) => {
        onChange(value)
    }, [onChange])

    return  <Tabs className={classes.container} value={mode} onChange={disabled ? undefined : onTabChange}>
                <Tab label="Regular" className={cx(classes.tab, {[classes.disabled]: disabled} )} value="regular"  />
                <Tab label="Trigger" className={cx(classes.tab, {[classes.disabled]: disabled} )} value="trigger" />
                {/* <Tab label="Iceberg" className={cx(classes.tab, {[classes.disabled]: disabled} )} value="iceberg" /> */}
            </Tabs>;
};

export default memo(QuickTradeProductTabs)